import React, { Fragment } from "react";
import MetaData from "src/react/components/meta-data";
import metaData from "src/data/meta-data";
import OurStorySection from "src/react/pages/our-story/components/our-story-section";
import CallToAction from "src/react/components/call-to-action";
import CompanyBadges from "src/react/components/company-badges";
import CouponAppliedMessage from "src/react/pages/signup/components/coupon-applied-message";

function OurStory() {
  return (
    <Fragment>
      <MetaData data={metaData.ourStory} />
      <CouponAppliedMessage />
      <OurStorySection />
      <CallToAction />
      <CompanyBadges />
    </Fragment>
  );
}

export default OurStory;
